/* eslint-disable import/no-unresolved */

import React from 'react';

import ServicesHeading from '../../components/SoftwareServices/ServicesHeading';
import Layout from '../../components/Layout';
import PartialsHeader from '../../components/Partials/PartialsHeader';
import ResultsCardSwiperSection from '../../components/ResultsCardSwiperSection';
import HomeKnowledge from '../../components/Home/HomeKnowledge';
import LandingPageInfoBox from '../../components/LandingPages/LandingPageInfoBox';
import SingleBox from '../../components/Careers/careersPartials/SingleBox';
import Banner from '../../components/service/Products/productsPartials/DevOpsBanner';
import HomeTestimonials from '../../components/Home/HomeTestimonials';
import imagesPillarPages from '../../components/imagesPillarPages';
import imagesLandingPages from '../../components/imagesLandingPages';
import Softwares from '../../components/SoftwareServices/Softwares';
import SoftwareCustomColumns from '../../components/SoftwareServices/SoftwareCustomColumns';
import TelecommunicationSection from '../../components/SoftwareServices/TelecommunicationSection';

import content from '../../components/SoftwareServices/content-python-development';

const SoftwareServices = () => {
  return (
    <Layout
      title="Python software development | Ulam Labs"
      description="Build powerful digital products in Python - it’s the best programming language for your backend."
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">Python Development Services</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <ServicesHeading headingText={content.headingText} />
      <SoftwareCustomColumns
        borderBot
        pythonMode
        customColumnsText={content.customColumnsText}
      />
      <div className="telecommunication text-format mb-5">
        <Softwares content={content.softwaresText} />
      </div>
      <div className="version-pillar" style={{ background: '#eaebf1' }}>
        <HomeTestimonials
          customTitle="What our clients say about our software development services?"
          customSubtitle="Founders, CEOs and top managers from all over the world value our services especially for smooth communication,
            expertise and timely product delivery. Read customer opinions which prove that we are perfect technology partner for you as well."
        />
      </div>
      <div className="container">
        <div className="row">
          <h2 className="col subtitle without bigger my-5">
            Python projects we’ve delivered
          </h2>
        </div>
      </div>
      <div className=" js-swiper">
        <ResultsCardSwiperSection
          title="See related projects"
          buttonsAround={false}
          className="basis-slider"
          useSpecificCases={[
            'cryptocurrency-lending-platform',
            'full-stack-support-mobile-operator',
            'software-for-construction-sector'
          ]}
          onlySlider
        />
      </div>
      <TelecommunicationSection
        telecomSectionData={content.telecomSectionData}
      />
      <div className="container padd-b my-5">
        <h2 className="subtitle bigger without">
          Why work with our Python developers?
        </h2>
        <div className="work-with d-flex flex-column flex-md-row justify-content-between">
          <LandingPageInfoBox
            icon={imagesLandingPages.pythonSVG}
            title="Python is our core business"
            description="Ulam Labs has been developing services in Python since the beginning."
          />
          <LandingPageInfoBox
            icon={imagesPillarPages.consultingSVG}
            title="Experienced engineers"
            description="Work daily with skilled and experienced Python developers."
          />
          <LandingPageInfoBox
            icon={imagesLandingPages.teamextensionSVG}
            title="Flexible collaboration"
            description="Get a dedicated team of Python developers full-time, part-time, or hourly. 
            Scale up your team according to your needs."
          />
        </div>
        <div className="work-with d-flex flex-column flex-md-row justify-content-between">
          <LandingPageInfoBox
            icon={imagesLandingPages.outcomeSVG}
            title="Excellent communication"
            description="Communication is as important for Ulam Labs as technical knowledge. 
            You can be sure that we put effective and timely communication as one of our priorities."
          />
          <LandingPageInfoBox
            icon={imagesLandingPages.icon4SVG}
            title="Complementary services"
            description="In addition to Python programming, we have everything you need for a long-term, end-to-end tech partnership."
          />
          <LandingPageInfoBox
            icon={imagesLandingPages.ourroleSVG}
            title="Client's trust"
            description="More than 90% of our customers come back with their new projects and recommend our services."
          />
        </div>
      </div>
      <div className="container my-4 my-md-0 services-banner-top">
        <Banner
          customTitle="Our approach to software development"
          customSubtitle="Find out how we develop services in Python for our clients"
        />
      </div>
      <div className="knowledge-services padd-t-sm padd-b-sm">
        <HomeKnowledge
          useSpecificPostsByTag={['Python']}
          customTitle="Read about Python on our blog"
          customSubtitle="Our team of developers takes active part in
          creating educational and valuable content for our clients who are thinking about Python web development.
          Read our blog to understand the technology better and know how to use Python to solve a variety of real-world
          problems."
          versionPillar
        />
      </div>
      <div className="container my-4 my-md-0 services-banner-top">
        <Banner
          customTitle="Looking for Python developers for your project?"
          version="servicesPage"
        />
      </div>
      <div className="version-pillar pb-5 container padd-t">
        <div className="info-box">
          <div>
            <h3 className="subtitle without bigger">
              What other services do we offer?
            </h3>
            <div className="row">
              <SingleBox
                image={imagesPillarPages.logoJS}
                heading="JavaScript development"
                url="/software-services/javascript-development/"
              />
              <SingleBox
                image={imagesPillarPages.chainSVG}
                heading="Blockchain development"
                url="/software-services/blockchain-development/"
              />
              <SingleBox
                image={imagesPillarPages.codeauditSVG}
                heading="Code audit"
                url="/software-services/code-audit/"
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SoftwareServices;
